import {
  BUILD_ASSET,
  ASSET_CHANGED,
  UPDATE_ASSETS_START,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_ASSETS_FAILURE,
} from './types';

export const buildAsset = (payload) => ({
  type: BUILD_ASSET,
  payload: payload
})

export const assetChanged = (payload) => ({
  type: ASSET_CHANGED,
  payload: payload,
})

export const updateAssetsStart = (payload) => ({
  type: UPDATE_ASSETS_START,
  payload: payload,
})

export const updateAssetsSuccess = (payload) => ({
  type: UPDATE_ASSETS_SUCCESS,
  payload: payload,
})

export const updateAssetsFailure = (payload) => ({
  type: UPDATE_ASSETS_FAILURE,
  payload: payload,
})
